// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"1e611798","433":"3bc202cd","488":"7a5ac1e3","879":"0ec45c6d"}[chunkId] + ".chunk.js";
};